import { createSlice } from "@reduxjs/toolkit";
import { storage, auth, loginPromise } from "../../helpers/Firebase";
import {
  ref,
  getDownloadURL,
  deleteObject,
  uploadString,
  uploadBytesResumable,
} from "firebase/storage";
// import { onAuthStateChanged } from "firebase/auth";

const initialState = {
  Storage: [],
  user: [],
};

export const firebaseSlice = createSlice({
  name: "firebaseSliceState",
  initialState,
  reducers: {
    updateGetFirebaseStorage: (state, action) => {
      state.Storage = action.payload;
    },
    updateGetUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const addToStorage = async (dataUrl, path_name, contentType) => {
  const storageRef = ref(storage, path_name);

  const uploadTask = uploadString(storageRef, dataUrl, "data_url", {
    contentType,
  });

  return uploadTask
    .then(async (snapshot) => {
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    })
    .catch((error) => {
      console.error("Error uploading data:", error);
      return "";
    });
};

// export const addToStorage = async (dataUrl, path_name, contentType) => {
//   const storageRef = ref(storage, path_name);

//   const metadata = {
//     contentType: contentType,
//   };

//   const uploadTask = uploadBytesResumable(
//     storageRef,
//     Buffer.from(dataUrl.split(",")[1], "base64"),
//     metadata
//   );

//   return new Promise((resolve, reject) => {
//     uploadTask.on(
//       "state_changed",
//       (snapshot) => {
//         const progress =
//           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

//         switch (snapshot.state) {
//           case "paused":
//             break;
//           case "running":
//             break;
//         }
//       },
//       (error) => {
//         console.error("Error uploading data:", error);
//         reject("");
//       },
//       () => {
//         getDownloadURL(uploadTask.snapshot.ref)
//           .then((downloadURL) => {
//             resolve(downloadURL);
//           })
//           .catch((error) => {
//             console.error("Error getting download URL:", error);
//             resolve("");
//           });
//       }
//     );
//   });
// };

export const getImage = async (fileUrl) => {
  try {
    // console.log("🖼️ getImage path:", fileUrl);
    if (!fileUrl) {
      return null;
    }

    await loginPromise();

    const storageRef = ref(storage, fileUrl);
    const url = await getDownloadURL(storageRef);

    return { url };
  } catch {
    return null;
  }
};

export const deleteImageStorage = async (url) => {
  if (!url || typeof url !== "string") {
    console.error("Invalid or missing url");
    return;
  }

  const fileRef = ref(storage, url);

  try {
    await deleteObject(fileRef);

    return { status: "success", message: "File deleted successfully" };
  } catch (error) {
    console.error("error : ", error);
    return {
      status: "error",
      message: `Error deleting file: ${error.message}`,
    };
  }
};

export const { updateGetUser } = firebaseSlice.actions;

export const { updateGetFirebaseStorage } = firebaseSlice.actions;
export const getFirebaseStorage = () => async (dispatch) => {
  try {
    const user = await loginPromise();

    if (user) {
      dispatch(updateGetFirebaseStorage(user));
    } else {
      console.warn("⚠️ Firebase login failed or user not available");
    }
  } catch (err) {
    console.error("❌ Error in getFirebaseStorage:", err);
  }
};

export default firebaseSlice.reducer;
